import TemplateView from "../../TemplateView"
import AuditHistoryView from "../auditHsitory/AuditHistoryView"
import CustomerStatusButton from  "../../controls/task/CustomerStatusButton"
import {WorkflowStatusType} from "../../workflowStatus/constants";
import ProjectPanelTimeDetails from "./ProjectPanelTimeDetails";

export default class ProjectPanelDetails extends TemplateView {
    constructor($containerEl) {
        super($containerEl);
        this.state = {
            active: false,
            readOnly: false,
            projectSpentTimeValues: null,
            workflowStatuses: [],
            canReopenProject: false,
        }

        this.onAnyStatePropertyChanged(['projectSpentTimeValues', 'workflowStatuses'], () => {
            this.updateSpentTime()
        })

        this.onStatePropertyChanged('canReopenProject', () => {
            this.updateInactiveOpenStatus()
        })

        this.onStatePropertyChanged('active', () => {
            this.statusButton.setActive(this.state.active)
        })

        this.onStatePropertyChanged('readOnly', () => {
            this.statusButton.setEditable(!this.state.readOnly)
        })
    }

    templateHtml() {
        return "<div class='details'>" +
               "  <div class='auditHistoryPlaceholder'/>" +
               "  <div class='detailsColumn'>" +
               "    <div class='title'><%=details%></div>" +
               "    <div class='status'><%=status%></div>" +
               "    <div class='statusButton'></div>" +
               "  </div>" +
               "  <div class='timeDetails'></div>" +
               "</div>";
    }

    shouldUpdateOnInit() {
        return false;
    }

    messageKeys() {
        return {
            status: "common.status",
            details: "customer.edit_panel.details"
        }
    }

    afterRender() {
        this.auditHistory = new AuditHistoryView({
            extraClass: 'projectAudit',
        }).init(this.find('.auditHistoryPlaceholder'));
        const dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");
        this.auditHistory.setDateFormat(dateFormat);

        this.statusButton = new CustomerStatusButton({
            editable: true,
        }).init(this.find(".statusButton"))
        this.$timeDetails = this.find('.timeDetails')
        this.timeTable = new ProjectPanelTimeDetails().init(this.$timeDetails);

        this.updateInactiveOpenStatus()
    }

    updateSpentTime() {
        if (this.state.projectSpentTimeValues) {
            this.timeTable.show()
            const totalOpenTime = this.state.projectSpentTimeValues.totalTime.map[WorkflowStatusType.OPEN]
            const totalCompletedTime = this.state.projectSpentTimeValues.totalTime.map[WorkflowStatusType.COMPLETED]
            const totalTime = totalOpenTime + totalCompletedTime
            const showDetailedInfo = !!this.state.projectSpentTimeValues.timeByStatuses
            const timeByStatuses = showDetailedInfo ? this.state.projectSpentTimeValues.timeByStatuses.map : null
            this.timeTable.setState({
                totalTime,
                totalOpenTime,
                totalCompletedTime,
                statuses: this.state.workflowStatuses,
                timeByStatuses,
                showDetailedInfo
            })

        } else {
            this.timeTable.hide()
        }
    }

    updateInactiveOpenStatus() {
        this.statusButton.setInactiveOpenStatus(!this.state.canReopenProject)
    }

    setProjectId(projectId) {

    }

    hideSelectors() {
        this.statusButton.disableAndHide();
    }

    setSelectorsDisabled(disabled) {
        this.statusButton.setDisabled(disabled);
    }

    clearAuditHistory() {
        this.auditHistory.hide();
    }

    setAuditHistory(createAction, lastUpdateAction) {
        this.auditHistory.setAuditActions(createAction, lastUpdateAction, []);
    }

    setLastAudit(lastUpdateAudit) {
        this.auditHistory.setLastAuditAction(lastUpdateAudit)
    }

    hideAuditHistoryMenu() {
        this.auditHistory.auditHistoryMenu.hide();
    }

    addAuditRecords(auditRecords) {
        this.auditHistory.addRecords(auditRecords);
    }

    setAuditRecords(auditRecords) {
        this.auditHistory.setRecords(auditRecords);
    }
}




// WEBPACK FOOTER //
// ./web/js/panels/project/ProjectPanelDetails.js